import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const filesManifest: FeatureManifest = {
  id: 'resource-files',
  path: 'resources/files/*',
  navPath: '/resources/files',
  label: 'File',
  description: 'Quản lý file tập trung',
  navigationGroup: { id: 'resources', label: 'Quản lý tài nguyên' },
  load: () => import('./entry'),
}
